import React, { useEffect } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import SelfIntroduction from "./App/SelfIntroduction";
import Experience from "./App/Experience";
import EducationCertifications from "./App/EducationCertifications";
import OSVisitGraph from "./App/OSVisitGraph";
import TimeZonesWorldMap from "./App/TimeZonesWorldMap";
import AboutMe from "./App/AboutMe";
import Contact from "./App/Contact";
import Navbar from "./App/Navbar";
import SidebarNav from "./App/SidebarNav";
import CheckEmailPage from "./CheckEmailPage";
import AuthPage from "./AuthPage";
import UserPage from "./UserPage";
import OAuthRedirect from "./OAuthRedirect";
import VerifyEmailPage from "./VerifyEmailPage";
import WeatherQuery from "./User/WeatherQuery";
import News from "./User/news";
import Movie from "./User/movies";
import Leetcode from "./User/leetcode";
import Footer from "./App/Footer";
import axios from "axios";

const App = () => {
  useEffect(() => {
    const getOS = () => {
      const userAgent = window.navigator.userAgent;
      if (/Android/.test(userAgent)) return "Android";
      if (/iPhone|iPad|iPod/.test(userAgent)) return "iOS";
      if (userAgent.indexOf("Win") !== -1) return "Windows";
      if (userAgent.indexOf("Mac") !== -1) return "MacOS";
      if (userAgent.indexOf("Linux") !== -1) return "Linux";
      return "Others";
    };

    const logVisit = () => {
      const os = getOS();
      const visitCount = 1;
      axios.post("/api/track-visit/", { os, visit_count: visitCount })
        .then(response => console.log("Visit logged:", response.data))
        .catch(error => console.error("Error logging visit:", error));
    };

    logVisit();
  }, []);
  const sections = [
    "self-introduction",
    "experience",
    "education-certifications",
    "os-visit-graph",
    "time-zones-world-map",
    "about-me",
    "contact",
  ];
  return (
    <div>
      <Router>
      <Routes>
        {/* Route for AuthPage */}
        <Route path="/news" element={<News />} />
        <Route path="/movies" element={<Movie/>} />
        <Route path="/leetcode" element={<Leetcode />} />
        <Route path="/weather" element={<WeatherQuery />} />
        <Route path="/oauth/callback" element={<OAuthRedirect />} />
        <Route path="/auth" element={<AuthPage />} />
        <Route path="/user" element={<UserPage />} />
        <Route path="/verify-email/:token" element={<VerifyEmailPage />} />
        <Route path="/check-email" element={<CheckEmailPage />} />
        {/* Routes for Homepage */}
        <Route
          path="/"
          element={
            <div>
              <Navbar />
              <div style={{ display: "flex" }}>
                <SidebarNav sections={sections} />
                <main style={{ marginLeft: "0px", width: "100%" }}>
                  <SelfIntroduction />
                  <Experience />
                  <EducationCertifications />
                  <OSVisitGraph />
                  <TimeZonesWorldMap />
                  <AboutMe />
                  <Contact />
                </main>
              </div>
              <Footer />
            </div>
          }
        />
      </Routes>
    </Router>
    </div>
  );
};

export default App;
